import { z } from "zod";

import { generalMedicalProblemsData, specificMedicalProblemsData } from "@constants/patientForms";

import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Past Medical History validation schema
 * Validates the entire past medical history category
 */

const specificMedicalProblemSchema = multiSelectResponseSchema.extend({
  type: z.enum(["Medical", "Surgical"]).optional(),
});

export const pastMedicalHistoryValidation = z.object({
  hasPaceMaker: z.boolean(),
  generalMedicalProblems: z.array(multiSelectResponseSchema),
  specificMedicalProblems: z.array(specificMedicalProblemSchema),
});

export default pastMedicalHistoryValidation;
